import { useNavigate } from 'react-router-dom'

import { useClientReservations } from '@/entities/reservation/lib/useClientReservations'
import { Badge } from '@/shared/ui/badge'
import { Card, CardContent } from '@/shared/ui/card'
import { Client } from '@monorepo/functions/src/types/client'

import { ClassificationBadge } from '../../../../entities/client/ui/classification-badge'

type ClientCardProps = {
    client: Client
}

export function ClientCard({ client }: ClientCardProps) {
    const navigate = useNavigate()
    const { activeReservations, totalSpent, lastReservationDate } = useClientReservations(client.id)

    return (
        <Card
            className='cursor-pointer transition-shadow hover:shadow-md'
            onClick={() => navigate(`/panel-interno/clientes/${client.id}`)}
        >
            <CardContent className='p-4'>
                <div className='mb-4 flex items-start justify-between'>
                    <div>
                        <h3 className='text-xl font-semibold'>
                            {client.name} {client.lastName}
                        </h3>
                        <p className='text-sm text-gray-600'>{client.phone}</p>
                        <p className='text-sm text-gray-600'>{client.email}</p>
                    </div>
                    <ClassificationBadge classification={client.classification} />
                </div>
                <div className='mb-4'>
                    <p className='text-sm text-gray-600'>Mascotas: {client.pets.map(pet => pet.name).join(', ')}</p>
                </div>
                <div className='mb-4 flex items-center justify-between'>
                    <Badge variant='secondary'>
                        {activeReservations} reserva{activeReservations !== 1 && 's'} activa
                        {activeReservations !== 1 && 's'}
                    </Badge>
                    <span className='text-sm text-gray-500'>Última reserva: {lastReservationDate}</span>
                </div>
                <div className='text-right'>
                    <span className='text-sm font-medium'>
                        Total gastado: {totalSpent?.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
                    </span>
                </div>
            </CardContent>
        </Card>
    )
}
